import React from 'react';
import { CheckCircleIcon, XCircleIcon, ClockIcon, InfoIcon } from 'lucide-react';
const ServiceCoveragePage = () => {
  return <div data-id="element-540">
      {/* Hero Section */}
      <section className="bg-[#0a3d62] text-white py-16" data-id="element-541">
        <div className="container mx-auto px-4" data-id="element-542">
          <div className="max-w-3xl mx-auto text-center" data-id="element-543">
            <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-544">
              Service Coverage
            </h1>
            <p className="text-lg text-gray-200" data-id="element-545">
              Comprehensive information about our service plans, coverage, and
              what you can expect
            </p>
          </div>
        </div>
      </section>
      {/* Service Activation Section */}
      <section className="py-16" data-id="element-546">
        <div className="container mx-auto px-4" data-id="element-547">
          <div className="max-w-4xl mx-auto" data-id="element-548">
            <h2 className="text-2xl font-bold text-[#0a3d62] mb-8" data-id="element-549">
              Service Activation & Start Date
            </h2>
            <div className="space-y-8" data-id="element-550">
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-551">
                <h3 className="text-xl font-semibold text-[#0a3d62] mb-4" data-id="element-552">
                  When does my cover begin?
                </h3>
                <p className="text-gray-700" data-id="element-553">
                  Your protection begins immediately once your payment is
                  processed. You will receive a confirmation email shortly
                  afterwards with all the details of your service plan.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-554">
                <h3 className="text-xl font-semibold text-[#0a3d62] mb-4" data-id="element-555">
                  Do I need to take any steps to activate my plan?
                </h3>
                <p className="text-gray-700" data-id="element-556">
                  No, activation happens automatically. Your plan begins as soon
                  as your purchase is complete and remains valid for the
                  duration of your selected plan (12 or 24 months).
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-557">
                <h3 className="text-xl font-semibold text-[#0a3d62] mb-4" data-id="element-558">
                  When does my coverage end?
                </h3>
                <p className="text-gray-700" data-id="element-559">
                  Your plan expires exactly 12 months (or 24 months for two-year
                  plans) later at 23:59 on the final day, unless you renew it
                  beforehand.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Request Repair Section */}
      <section className="py-16 bg-gray-50" data-id="element-560">
        <div className="container mx-auto px-4" data-id="element-561">
          <div className="max-w-4xl mx-auto" data-id="element-562">
            <h2 className="text-2xl font-bold text-[#0a3d62] mb-8" data-id="element-563">
              How Do I Request a Repair?
            </h2>
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-564">
              <p className="text-gray-700 mb-6" data-id="element-565">Please contact us by:</p>
              <div className="space-y-4 mb-6" data-id="element-566">
                <div className="flex items-center" data-id="element-567">
                  <span className="text-[#0a3d62] font-medium mr-3" data-id="element-568">📞</span>
                  <span className="text-gray-700" data-id="element-569">0800 055 4969</span>
                </div>
                <div className="flex items-center" data-id="element-570">
                  <span className="text-[#0a3d62] font-medium mr-3" data-id="element-571">📧</span>
                  <span className="text-gray-700" data-id="element-572">
                    Bikashbuddha2004@gmail.com
                  </span>
                </div>
              </div>
              <p className="text-gray-700" data-id="element-573">
                Our team will organise your repair appointment, usually within
                24 to 48 hours.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Coverage Details Section */}
      <section className="py-16" data-id="element-574">
        <div className="container mx-auto px-4" data-id="element-575">
          <div className="max-w-4xl mx-auto" data-id="element-576">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-577">
              {/* What's Included */}
              <div data-id="element-578">
                <h2 className="text-2xl font-bold text-[#0a3d62] mb-6" data-id="element-579">
                  What's Included?
                </h2>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-580">
                  <ul className="space-y-4" data-id="element-581">
                    <li className="flex items-start" data-id="element-582">
                      <CheckCircleIcon className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-583" />
                      <span className="text-gray-700" data-id="element-584">
                        Unlimited repair visits and callouts for appliances
                        covered during your plan period
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-585">
                      <CheckCircleIcon className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-586" />
                      <span className="text-gray-700" data-id="element-587">
                        All labour costs are covered
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-588">
                      <CheckCircleIcon className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-589" />
                      <span className="text-gray-700" data-id="element-590">
                        Replacement parts provided when available
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-591">
                      <CheckCircleIcon className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-592" />
                      <span className="text-gray-700" data-id="element-593">
                        Engineer appointments are generally booked within 24–48
                        hours after reporting a fault
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-594">
                      <CheckCircleIcon className="text-green-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-595" />
                      <span className="text-gray-700" data-id="element-596">
                        Coverage includes mechanical and electrical faults
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              {/* What's Not Covered */}
              <div data-id="element-597">
                <h2 className="text-2xl font-bold text-[#0a3d62] mb-6" data-id="element-598">
                  What's Not Covered?
                </h2>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-599">
                  <ul className="space-y-4" data-id="element-600">
                    <li className="flex items-start" data-id="element-601">
                      <XCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-602" />
                      <span className="text-gray-700" data-id="element-603">
                        Cosmetic damage or normal wear and tear of appliances
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-604">
                      <XCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-605" />
                      <span className="text-gray-700" data-id="element-606">
                        Faults that existed prior to your plan start date
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-607">
                      <XCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-608" />
                      <span className="text-gray-700" data-id="element-609">
                        Damage caused by misuse or unauthorised repairs
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-610">
                      <XCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-611" />
                      <span className="text-gray-700" data-id="element-612">
                        Appliances older than 10 years at the start of your plan
                      </span>
                    </li>
                    <li className="flex items-start" data-id="element-613">
                      <XCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-614" />
                      <span className="text-gray-700" data-id="element-615">
                        Damage due to floods, fires, or other natural disasters
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Additional Information */}
      <section className="py-16 bg-gray-50" data-id="element-616">
        <div className="container mx-auto px-4" data-id="element-617">
          <div className="max-w-4xl mx-auto" data-id="element-618">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-619">
              {/* Service Area */}
              <div data-id="element-620">
                <h2 className="text-2xl font-bold text-[#0a3d62] mb-6" data-id="element-621">
                  Service Area
                </h2>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-622">
                  <p className="text-gray-700 mb-4" data-id="element-623">
                    We currently provide services across mainland UK postcodes
                    only. For remote areas, response times may be longer.
                  </p>
                  <p className="text-gray-700 flex items-start" data-id="element-624">
                    <InfoIcon className="text-[#3fc1c9] mr-3 mt-1 flex-shrink-0" size={20} data-id="element-625" />
                    <span data-id="element-626">
                      Please contact us to confirm if your location is covered.
                    </span>
                  </p>
                </div>
              </div>
              {/* Response Times */}
              <div data-id="element-627">
                <h2 className="text-2xl font-bold text-[#0a3d62] mb-6" data-id="element-628">
                  Response Times
                </h2>
                <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-629">
                  <div className="flex items-start mb-4" data-id="element-630">
                    <ClockIcon className="text-[#3fc1c9] mr-3 mt-1 flex-shrink-0" size={20} data-id="element-631" />
                    <p className="text-gray-700" data-id="element-632">
                      We aim to schedule engineer visits within 24 to 48 hours,
                      excluding weekends and public holidays.
                    </p>
                  </div>
                  <p className="text-gray-700" data-id="element-633">
                    For emergency repairs, we strive to provide same-day service
                    when possible, subject to engineer availability.
                  </p>
                </div>
              </div>
            </div>
            {/* Plan Exclusions */}
            <div className="mt-12" data-id="element-634">
              <h2 className="text-2xl font-bold text-[#0a3d62] mb-6" data-id="element-635">
                Plan Exclusions & Prohibited Use
              </h2>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-636">
                <p className="text-gray-700 mb-6" data-id="element-637">
                  To ensure fair use and maintain service quality, the following
                  are excluded from cover:
                </p>
                <ul className="space-y-3 text-gray-700" data-id="element-638">
                  <li className="flex items-start" data-id="element-639">
                    <XCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-640" />
                    <span data-id="element-641">
                      Damage or faults existing before your plan started
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-642">
                    <XCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-643" />
                    <span data-id="element-644">Damage caused by neglect, misuse, or tampering</span>
                  </li>
                  <li className="flex items-start" data-id="element-645">
                    <XCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-646" />
                    <span data-id="element-647">Repairs unrelated to normal appliance operation</span>
                  </li>
                  <li className="flex items-start" data-id="element-648">
                    <XCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-649" />
                    <span data-id="element-650">
                      Any illegal or fraudulent use of our services or website
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-651">
                    <XCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-652" />
                    <span data-id="element-653">
                      Appliances used contrary to manufacturer instructions
                    </span>
                  </li>
                </ul>
                <div className="mt-6 p-4 bg-red-50 rounded-md" data-id="element-654">
                  <p className="text-red-700 font-medium" data-id="element-655">
                    Please note: If any of these exclusions apply, your plan may
                    be cancelled without refund or further support.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default ServiceCoveragePage;